import React, { useState } from 'react'
import { TabView, TabPanel } from 'primereact/tabview';
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from 'primereact/button';
import UserLeaveDialog from '../UserLeaveDialog';
import UserLeaves from '../../../../leaves/views/user-leaves';
import '../style.scss';
const LeaveAdmin = ({ clickedUserData }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const ActionTemplate = (r) => {
        return (<>

        </>)
    }
    return (
        <div className='mt-2' style={{ background: '#fff', border: '2px solid #f1f5f9' }}>
            <div className='panel' style={{ background: 'rgb(241 245 249)', border: '2px solid #f1f5f9', padding: '5px' }}>
                <Button label='Applied Leaves' className={classNames(activeIndex === 0 ? 'p-button-primary' : 'p-button p-button-white')} onClick={() => setActiveIndex(0)} />
                <Button label='Leave Balances' className={classNames(activeIndex === 1 ? 'p-button-primary' : 'p-button p-button-white')} onClick={() => setActiveIndex(1)} />
            </div>

            <div className='p-2'>
                {activeIndex === 0 && <div>
                    <UserLeaves selectedUser={clickedUserData} isDialog={false} />
                </div>}
                {activeIndex === 1 && <div>
                    <UserLeaveDialog clickedUserData={clickedUserData} isDialog={false} />
                </div>}

            </div>

        </div>
    )
}

export default LeaveAdmin